import ObservableState from 'global/js/ObservableState';
import { SelectOptionTypes } from 'global/react-mui/atoms/Select';
import { fromEvent, Subscription } from 'rxjs';
import ControllerBase from '../../../../global/js/ControllerBase';
import { MoleculeSystemComponentProps } from '../m-formstep-system-component/m-formstep-system-component.data';
import { AppDataTypes, WARRANTY_WOLF_PRODUCT_APP_DATA_ID } from './m-formstep-warranty-wolf-products.data';
import controller from 'wolf/global/js/controller';
import { MoleculeFormStepResumeSliceProps } from '../m-formstep-resume-slice/m-formstep-resume-slice.data';
import { ResumeSliceEvents } from '../m-formstep-resume-slice/m-formstep-resume-slice.controller';
import { FormstepWarrantyWolfProductsEvents } from './m-formstep-warranty-wolf-products.events';
import { ControlledFormSlice, FormStepperValidationEvent, FormStepperValidationEventClientServerEnum, OrganismFormStepperEvents, OrganismFormStepperEventTypes, ResumeSliceSummary } from 'wolf/components/organisms/o-form-stepper/o-form-stepper.events';
import { FormstepSystemComponentEvents } from '../m-formstep-system-component/m-formstep-system-component.events';
import { GenericFormStepValidationResponseWithSliceResponse } from 'wolf/components/organisms/o-form-stepper/o-form-stepper.types';
// import { ValidationMainComponentResponse, ValidationSystemComponentResponse } from './m-formstep-warranty-wolf-products.types';

const systemComponentMolecule = require('components/molecules/m-formstep-system-component/m-formstep-system-component.template.twig') as any;
const resumeSliceMolecule = require('components/molecules/m-formstep-resume-slice/m-formstep-resume-slice.template.twig') as any;

type ComponentRefs = {
	installationDateInput: 'm-formstep-main-part-component__installation-date',
	serialNumberInput: 'm-formstep-main-part-component__serial-number',
	addComponentButton: 'm-formstep-add-system-component__button',
	mainPartBaseInputBox: 'm-formstep-main-part-component__main-part-base-inputs-box',
	mainPartContainer: 'm-formstep-warranty-wolf-products__main-part-container',
	mainPartFieldset: 'm-formstep-warranty-wolf-products__main-part-fieldset',
	systemComponentsContainer: 'm-formstep-warranty-wolf-products__systemComponents-container',
	partsContainer: 'm-formstep-warranty-wolf-products__parts-container',
};

type MainPartState = {
	type?: string,
	serialNumber: string,
	installationDate: string
}

type SubComponent = {
	id: string,
	componentName: string,
	componentPart: string,
	serialNumber?: string,
	shortDescription: string,
	systemComponentPartOptions: MoleculeSystemComponentProps['componentPartOptions'],
}

type StepOneState = {
	mainPart: MainPartState,
	systemComponents: SubComponent[]
}

const systemComponentIdPrefix = 'system-component-'

const getDefaultSystemComponentData = (
	currentSystemComponentsAdded: number,
	systemComponentPartOptions: MoleculeSystemComponentProps['componentPartOptions'],
	componentTitlePrefix: string
): SubComponent => ({
	id: `${systemComponentIdPrefix}${currentSystemComponentsAdded + 1}`,
	componentName: componentTitlePrefix + ` ${currentSystemComponentsAdded + 1}`,
	serialNumber: '',
	shortDescription: '',
	systemComponentPartOptions,
	componentPart: systemComponentPartOptions[0].value
})

const defaultState: StepOneState = {
	mainPart: {
		serialNumber: '',
		installationDate: ''
	},
	systemComponents: []
}

export default class ControllerFormstepWarrantyWolfProducts extends ControllerBase<ComponentRefs> {
	private appData: AppDataTypes
	private serialNumberInput: HTMLInputElement
	private installationDateInput: HTMLInputElement
	private addComponentButton: HTMLButtonElement
	private subComponentOptions: SelectOptionTypes[]
	private mainPartBaseInputBox: HTMLDivElement
	private mainPartContainer: HTMLDivElement
	private mainPartFieldset: HTMLFieldSetElement
	private systemComponentsContainer: HTMLDivElement
	private partsContainer: HTMLDivElement

	private validatedComponentResumeSlicesById: Record<'mainPart' | 'systemComponent', Record<string, HTMLElement>> = {
		mainPart: {},
		systemComponent: {}
	}

	private validatedComponentFieldsetById: Record<'mainPart' | 'systemComponent', Record<string, HTMLElement>> = {
		mainPart: {},
		systemComponent: {}
	}

	private resumeSlices: MoleculeFormStepResumeSliceProps[] = []

	private currentEditedComponentId: string | null

	// THIS SHOULD BE DONE ON CONSTRUCTOR AND POSSIBLY ADDED TO THE MAIN CONTROLLER
	private state: ObservableState<StepOneState>;

	private observableSubscriptions: Subscription[] = []

	private static readonly componentRefs: ComponentRefs = {
		installationDateInput: 'm-formstep-main-part-component__installation-date',
		serialNumberInput: 'm-formstep-main-part-component__serial-number',
		addComponentButton: 'm-formstep-add-system-component__button',
		mainPartBaseInputBox: 'm-formstep-main-part-component__main-part-base-inputs-box',
		mainPartContainer: 'm-formstep-warranty-wolf-products__main-part-container',
		mainPartFieldset: 'm-formstep-warranty-wolf-products__main-part-fieldset',
		systemComponentsContainer: 'm-formstep-warranty-wolf-products__systemComponents-container',
		partsContainer: 'm-formstep-warranty-wolf-products__parts-container',
	};

	constructor(element: HTMLElement) {
		super(element, [], Object.values(ControllerFormstepWarrantyWolfProducts.componentRefs));
		this.serialNumberInput = this.$references[ControllerFormstepWarrantyWolfProducts.componentRefs.serialNumberInput]
		this.installationDateInput = this.$references[ControllerFormstepWarrantyWolfProducts.componentRefs.installationDateInput]
		this.addComponentButton = this.$references[ControllerFormstepWarrantyWolfProducts.componentRefs.addComponentButton]
		this.mainPartBaseInputBox = this.$references[ControllerFormstepWarrantyWolfProducts.componentRefs.mainPartBaseInputBox]
		this.mainPartContainer = this.$references[ControllerFormstepWarrantyWolfProducts.componentRefs.mainPartContainer]
		this.mainPartFieldset = this.$references[ControllerFormstepWarrantyWolfProducts.componentRefs.mainPartFieldset]
		this.systemComponentsContainer = this.$references[ControllerFormstepWarrantyWolfProducts.componentRefs.systemComponentsContainer]
		this.partsContainer = this.$references[ControllerFormstepWarrantyWolfProducts.componentRefs.partsContainer]
		this.currentEditedComponentId = this.mainPartFieldset.id
		this.initApp();
	}

	private initApp(): void {
		this.observeAndTrackMainComponent()
		this.observeAddSystemComponentButton()
		this.setAppData()
		this.domNodeListenerEvents()

		this.state = new ObservableState<typeof defaultState>(defaultState, {
			MANAGE_SUBMIT_COMPONENT_BUTTON_STATE: {
				callback: this.manageSubmitComponentButtonState,
				deps: ['mainPart', 'systemComponents']
			},
		});
	}

	/**
	 * Tell o-form-stepper to enable/disable the next step button
	 */
	private disableNextStepNavigation(isDisabled: OrganismFormStepperEventTypes['DISABLE_GO_TO_NEXT_STEP']) {
		this.dispatchCustomEvent(OrganismFormStepperEvents.DISABLE_GO_TO_NEXT_STEP, isDisabled, false, true)
	}

	private verifyActiveSystemComponentStatus = () => {
		const currentState = this.state.get()
		const hasSystemComponents = currentState.systemComponents.length > 0
		const activeSystemComponentRequiredFieldsFilled = hasSystemComponents && currentState.systemComponents.find(({ id }) => id === this.currentEditedComponentId)?.shortDescription
		const latestSystemComponentHasBeenCompleted = hasSystemComponents && currentState.systemComponents[currentState.systemComponents.length - 1].shortDescription.length > 0

		return { hasSystemComponents, activeSystemComponentRequiredFieldsFilled, latestSystemComponentHasBeenCompleted }
	}

	/**
	* This method is a side effect for the observable state
	*/
	private manageSubmitComponentButtonState = (state: typeof defaultState): void => {
		const mainPartHasBeenCompleted = state.mainPart.installationDate.length && state.mainPart.serialNumber.length
		const { hasSystemComponents, activeSystemComponentRequiredFieldsFilled } = this.verifyActiveSystemComponentStatus()
		const shouldEnableAddButton = (mainPartHasBeenCompleted || (mainPartHasBeenCompleted && this.currentEditedComponentId && !Object.keys(this.validatedComponentFieldsetById.systemComponent).includes(this.currentEditedComponentId)))
		const shouldDisableAddButton = !mainPartHasBeenCompleted || (hasSystemComponents && activeSystemComponentRequiredFieldsFilled && !activeSystemComponentRequiredFieldsFilled)

		if (shouldEnableAddButton && this.addComponentButton.disabled) {
			this.domUtils.toggleElementState(this.addComponentButton, ['enable'])
		} else if (shouldDisableAddButton && !this.addComponentButton.disabled) {
			this.domUtils.toggleElementState(this.addComponentButton, ['disable'])
		}

		if (mainPartHasBeenCompleted) this.disableNextStepNavigation(false)
		else this.disableNextStepNavigation(true)
	}

	/**
	* This method is in charge of adding subscription to a monitored Array to permits unsubscription once the component is unmount
	* @param {Subscription[]} subscriptions - The event passed from the observable
	*/
	private addSubscriptionToMonitoredCollection(subscriptions: Subscription[]): void {
		this.observableSubscriptions.push(...subscriptions)
	}

	/**
	 * This method is in charge of updating the observable state
	 * @param {any} value - value to update
	 * @param {string} path - path to update
	 */
	private updateState = (value: any, path: string): void => {
		if (path.includes('/')) {
			const [parentStateKey, keyToUpdate] = path.split('/')
			this.state.set((prevState) => ({ ...prevState, [parentStateKey]: { ...prevState[parentStateKey], [keyToUpdate]: value } }));
		} else {
			this.state.set((prevState) => ({ ...prevState, [path]: value }));
		}
	}


	/**
	* Render the resume slice
	* @returns {HTMLElement} the slice to render
	*/
	renderResumeSlice(data: MoleculeFormStepResumeSliceProps): string {
		const resumeSlice = resumeSliceMolecule({ data })
		return resumeSlice
	}

	/**
	 * Render the resume slice
	 * @returns {HTMLElement} the slice to render
	 */
	replaceValidatedFieldsetWithResumeSlice(element: HTMLElement, resumeSliceString: string, elementToHide: HTMLElement): HTMLElement {
		const newElement = this.domUtils.appendRawHtmlToDomElement(element, resumeSliceString, 'beforebegin')
		new controller.ControllerFormStepResumeSlice(newElement as HTMLDivElement)
		this.domUtils.toggleElementState(elementToHide, ['hide'])
		return newElement as HTMLElement
	}

	/**
	 * Add the latest system component to the DOM
	 */
	private addSystemComponentToDom(): void {
		const currentSystemComponents = this.state.get().systemComponents
		let lastIdWithoutPrefix = currentSystemComponents.length;

		if(lastIdWithoutPrefix > 0) {
			// get the last element in current
			const lastComponent = currentSystemComponents[lastIdWithoutPrefix - 1];

			if(lastComponent) {
				lastIdWithoutPrefix = parseInt(lastComponent.id.replace(systemComponentIdPrefix, ''));
			}
		}

		const systemComponentBaseData = getDefaultSystemComponentData(lastIdWithoutPrefix, this.subComponentOptions, this.appData.translations.componentTitlePrefix)

		currentSystemComponents.push(systemComponentBaseData)

		this.updateState(currentSystemComponents, 'systemComponents')

		const systemComponentData: MoleculeSystemComponentProps = {
			id: systemComponentBaseData.id,
			componentName: systemComponentBaseData.componentName,
			componentPartOptions: this.subComponentOptions,
			translations: this.appData.translations,
			icon: 'close-outlined-circle',
			defaultValues: {
				componentPart: this.subComponentOptions[0].value
			}
		}
		const systemComponent = systemComponentMolecule({ data: systemComponentData })
		this.currentEditedComponentId = systemComponentData.id

		const newElement = this.domUtils.appendRawHtmlToDomElement(this.systemComponentsContainer, systemComponent, 'beforebegin') as HTMLElement

		new controller.ControllerSystemComponent(newElement)

		this.observeAndTrackNewSystemComponent(systemComponentData.id)
		this.inputUtils.addFocusToInput({ element: newElement, inputName: 'serialNumber' })
		this.domUtils.toggleElementState(this.addComponentButton, ['disable'])
		this.partsContainer.scrollTop = this.partsContainer.scrollHeight;
	}

	/**
	* Create observer for the main part component
	*/
	observeAndTrackMainComponent = (): void => {
		this.inputUtils.observeElementEvents(this.serialNumberInput, 'input', (value: string) => this.updateState(value, 'mainPart/serialNumber'));
		this.inputUtils.observeElementEvents(this.installationDateInput, 'input', (value: string) => this.updateState(value, 'mainPart/installationDate'));
	}

	/**
	 * Create observer for the latest system component added
	 * @param {string} id - The id of the new component
	 */
	observeAndTrackNewSystemComponent = (id: string): void => {
		const systemComponentToObserve = document.getElementById(id)

		const serialNumberElement = systemComponentToObserve?.querySelector("input[name='serialNumber']") as HTMLInputElement
		const componentPartElement = systemComponentToObserve?.querySelector("select[name='componentPart']") as HTMLSelectElement
		const shortDescriptionElement = systemComponentToObserve?.querySelector("input[name='shortDescription']") as HTMLInputElement

		const updateSystemComponents = (value: string, keyToUpdate: 'serialNumber' | 'componentPart' | 'shortDescription') => {
			const currentSystemComponents = this.state.get().systemComponents
			const systemComponentToUpdate = currentSystemComponents.find(systemComponent => systemComponent.id === id)

			if (systemComponentToUpdate) {
				systemComponentToUpdate[keyToUpdate] = value
				this.updateState(currentSystemComponents, 'systemComponents')
			}
		}

		this.inputUtils.observeElementEvents(serialNumberElement, 'input', (value) => updateSystemComponents(value, 'serialNumber'));
		this.inputUtils.observeElementEvents(componentPartElement, 'change', (value) => updateSystemComponents(value, 'componentPart'));
		this.inputUtils.observeElementEvents(shortDescriptionElement, 'input', (value) => updateSystemComponents(value, 'shortDescription'));

		// this.addComponentButton.scrollIntoView();
	}

	/**
	 * Inform the m-form-stepper about the new resume slice
	 * @param {MoleculeFormStepResumeSliceProps} newResumeSlice - The id of the new component
	 */
	addSliceToStepResume(newResumeSlice: MoleculeFormStepResumeSliceProps): void {
		const resumeNeedsToBeUpdated = this.resumeSlices.some(({ id }) => id === newResumeSlice.id)
		if (resumeNeedsToBeUpdated) {
			const indexSliceToReplace = this.resumeSlices.findIndex(({ id }) => id === newResumeSlice.id)
			this.resumeSlices[indexSliceToReplace] = newResumeSlice
		} else this.resumeSlices.push(newResumeSlice)

		this.dispatchCustomEvent(OrganismFormStepperEvents.RECEIVE_RESUME_SLICE, { step: 0, resumeSlices: this.resumeSlices }, false, true)
	}

	/**
	 * Inform the m-form-stepper about the new resume slice
	 * @param {string} sliceId - The id of the new component
	 */
	removeSliceFromStepResume(sliceId: string): void {
		const indexSliceToRemove = this.resumeSlices.findIndex(({ id }) => id === sliceId)

		if (indexSliceToRemove > -1) {
			this.resumeSlices.splice(indexSliceToRemove, 1);

			this.dispatchCustomEvent(OrganismFormStepperEvents.RECEIVE_RESUME_SLICE, { step: 0, resumeSlices: this.resumeSlices }, false, true)
		}
	}

	sendControlledFormToParentStepper(data: ControlledFormSlice): void {
		this.dispatchCustomEvent(OrganismFormStepperEvents.RECEIVE_CONTROLLED_FORM_SLICE, data, false, true)
	}

	removeControlledFormToParentStepper(data: ControlledFormSlice): void {
		this.dispatchCustomEvent(OrganismFormStepperEvents.REMOVE_CONTROLLED_FORM_SLICE, data, false, true)
	}

	/**
	 * This method validates the main part component as it has been stored in state
	 */
	async validateMainPart(
		onValidationSuccess?: FormStepperValidationEvent['onValidationSuccess'],
		onValidationError?: FormStepperValidationEvent['onValidationError'],
		shouldAddSystemComponent: boolean = true
	): Promise<void> {
		const body = this.state.get().mainPart

		const response = await fetch(this.appData.endpoints.verifyMainComponent, {
			method: 'POST',
			body: JSON.stringify(body)
		})
		const parsedResponse: GenericFormStepValidationResponseWithSliceResponse = await response.json()

		if (parsedResponse.success && parsedResponse.data) {
			this.subComponentOptions = parsedResponse.data.componentPartOptions || []
			const moleculeAsTwigString = this.renderResumeSlice(parsedResponse.data.resumeSliceMolecule)
			const newElement = this.replaceValidatedFieldsetWithResumeSlice(this.mainPartContainer, moleculeAsTwigString, this.mainPartFieldset)
			this.validatedComponentResumeSlicesById.mainPart = { [parsedResponse.data.resumeSliceMolecule.id]: newElement }
			this.validatedComponentFieldsetById.mainPart[this.mainPartFieldset.id] = this.mainPartBaseInputBox

			if (shouldAddSystemComponent) {
				this.addSystemComponentToDom()
			} else {
				this.currentEditedComponentId = null
			}

			if (onValidationSuccess) onValidationSuccess(FormStepperValidationEventClientServerEnum.Frontend); // this is frontend because the controller does the validation, rather than the o-form-stepper!
			this.addSliceToStepResume(parsedResponse.data.resumeSliceMolecule)
			this.sendControlledFormToParentStepper({ stepId: 'mainComponent', formSlice: this.state.get().mainPart })
		} else if (parsedResponse.error) {
			this.inputUtils.addErrorsToFieldset({ errors: parsedResponse.error, element: this.mainPartBaseInputBox, onErrorsUpdated: () => this.domUtils.toggleElementState(this.addComponentButton, ['disable']) })
			if (onValidationError) onValidationError()
		}
	}

	/**
	 * Create observer for the latest system component added
	 */
	async validateSystemComponent(
		onValidationSuccess?: FormStepperValidationEvent['onValidationSuccess'],
		onValidationError?: FormStepperValidationEvent['onValidationError'],
		shouldAddSystemComponent: boolean = true
	): Promise<void> {

		const { systemComponents } = this.state.get()
		const editedSystemComponent = systemComponents.find(({ id }) => id === this.currentEditedComponentId)

		const response = await fetch(this.appData.endpoints.verifySubComponent, {
			method: 'POST',
			body: JSON.stringify(editedSystemComponent)
		})
		const parsedResponse: GenericFormStepValidationResponseWithSliceResponse = await response.json()

		if (parsedResponse.success && parsedResponse.data && this.currentEditedComponentId && editedSystemComponent) {
			const moleculeAsTwigString = this.renderResumeSlice(parsedResponse.data.resumeSliceMolecule)
			const elementToHide = document.getElementById(this.currentEditedComponentId) as HTMLElement
			const newElement = this.replaceValidatedFieldsetWithResumeSlice(document.getElementById(this.currentEditedComponentId) as HTMLElement, moleculeAsTwigString, elementToHide)
			this.validatedComponentResumeSlicesById.systemComponent[parsedResponse.data.resumeSliceMolecule.id] = newElement
			this.validatedComponentFieldsetById.systemComponent[this.currentEditedComponentId] = elementToHide

			this.sendControlledFormToParentStepper({
				stepId: this.currentEditedComponentId,
				formSlice: {
					componentName: editedSystemComponent.componentName,
					componentPart: editedSystemComponent.componentPart,
					serialNumber: editedSystemComponent.serialNumber || '',
					shortDescription: editedSystemComponent.shortDescription
				}
			})

			if (shouldAddSystemComponent) {
				this.addSystemComponentToDom()
			} else {
				this.currentEditedComponentId = null
			}

			if (onValidationSuccess) onValidationSuccess(FormStepperValidationEventClientServerEnum.Frontend, parsedResponse.data.resumeSliceMolecule)
			this.addSliceToStepResume(parsedResponse.data.resumeSliceMolecule)

		} else if (parsedResponse.error && this.currentEditedComponentId) {

			const newState = { ...editedSystemComponent }

			const systemComponentIndex = systemComponents.findIndex(({ id }) => id === this.currentEditedComponentId)
			systemComponents[systemComponentIndex] = newState as SubComponent

			this.updateState(systemComponents, 'systemComponents')
			this.inputUtils.addErrorsToFieldset({ errors: parsedResponse.error, element: document.getElementById(this.currentEditedComponentId), onErrorsUpdated: () => this.domUtils.toggleElementState(this.addComponentButton, ['disable']) })
			if (onValidationError) onValidationError()
		}
	}

	/**
	 * This method validate the latest system component as it has been stored in state
	 */
	observeAddSystemComponentButton(): void {
		const addComponentButton$ = fromEvent(this.addComponentButton, 'click');
		const addComponentButtonSubscription = addComponentButton$
			.subscribe((event) => {
				event.preventDefault()
				const { hasSystemComponents, activeSystemComponentRequiredFieldsFilled } = this.verifyActiveSystemComponentStatus()

				if (!this.mainPartFieldset.hasAttribute('hidden')) {
					this.validateMainPart()
				} else if (hasSystemComponents && activeSystemComponentRequiredFieldsFilled) {
					this.validateSystemComponent(undefined, undefined, true)
				} else if (Object.keys(this.validatedComponentFieldsetById.mainPart).length > 0 && !hasSystemComponents || !this.currentEditedComponentId) {
					this.addSystemComponentToDom()
				}
			});

		this.addSubscriptionToMonitoredCollection([
			addComponentButtonSubscription
		])
	}

	/**
	 * TODO: Launch this method when the component unmount to correctly delete subscription
	 */
	private destroyObservables(): void {
		this.observableSubscriptions.forEach(observable => observable.unsubscribe())
		this.observableSubscriptions = []
	}

	/**
	 * This method is in charge of collecting data from a script tag in the dom
	 */
	private setAppData = (): void => {
		const data = document.getElementById(WARRANTY_WOLF_PRODUCT_APP_DATA_ID) as HTMLScriptElement;
		this.appData = JSON.parse(data.innerText)
	}

	/**
	 * This method is in charge of verifying new events on window
	 */
	private domNodeListenerEvents(): void {

		/**
		 * This listener is in charge of handling system component removal if the component destroys itself
		 */
		window.addEventListener(FormstepSystemComponentEvents.REMOVE_SYSTEM_COMPONENT, (event: CustomEvent<{ elementId: string }>) => {
			const currentSystemComponents = this.state.get().systemComponents
			const systemComponentToRemoveIndex = currentSystemComponents.findIndex(systemComponent => systemComponent.id === event.detail.elementId)
			if (systemComponentToRemoveIndex > -1) {
				currentSystemComponents.splice(systemComponentToRemoveIndex, 1);
			}

			this.updateState(currentSystemComponents, 'systemComponents')

			// remove from resumeState
			this.removeSliceFromStepResume(event.detail.elementId)
			this.currentEditedComponentId = null
			// remove from controlledForm (important for final submit)
			this.removeControlledFormToParentStepper({ stepId: event.detail.elementId, formSlice: {} })
		});

		/**
		 * This listener is in charge of submitting a new system component on demand
		 */
		window.addEventListener(FormstepSystemComponentEvents.REQUEST_ADD_SYSTEM_COMPONENT, (event: CustomEvent<{ elementId: string }>) => {
			this.validateSystemComponent(undefined, undefined, false)
		});

		/**
		 * This listener is in charge of handling the validation or removal of a system component based on its current status
		 */
		window.addEventListener(FormstepSystemComponentEvents.EXIT_EDIT_MODE, (event: CustomEvent<{ elementId: string }>) => {
			const { activeSystemComponentRequiredFieldsFilled } = this.verifyActiveSystemComponentStatus()
			if (activeSystemComponentRequiredFieldsFilled) {
				this.validateSystemComponent(undefined, undefined, false)
			} else {
				document.getElementById(event.detail.elementId)?.remove()
				this.dispatchCustomEvent(FormstepSystemComponentEvents.REMOVE_SYSTEM_COMPONENT, { elementId: event.detail.elementId }, false, true)
			}
		});


		/**
		 * This listener is waiting for a validation request from the parent form stepper
		 */
		window.addEventListener(FormstepWarrantyWolfProductsEvents.REQUEST_VALIDATION, (event: CustomEvent<FormStepperValidationEvent>) => {
			// @todo - check this...
			const shouldValidateMainPart = !Object.keys(this.validatedComponentResumeSlicesById.mainPart).length
			const hasSystemComponentToValidate = !!this.currentEditedComponentId
			// console.log({
			// 	shouldValidateMainPart,
			// 	hasSystemComponentToValidate, event
			// })
			if (shouldValidateMainPart) {
				this.validateMainPart(event.detail.onValidationSuccess, event.detail.onValidationError, false);
			} else if (hasSystemComponentToValidate) {
				this.validateSystemComponent(event.detail.onValidationSuccess, event.detail.onValidationError, false)
			} else if (event.detail.onValidationSuccess) {
				// event.detail.onValidationSuccess(FormStepperValidationEventClientServerEnum.Frontend)
				event.detail.onValidationSuccess(FormStepperValidationEventClientServerEnum.Frontend)
			}
		});

		/**
		 * This listener is in charge of toggling the inputs for a resume slice and viceversa
		 */
		window.addEventListener(ResumeSliceEvents.TOGGLE_SLICE_FOR_INPUTS, (event: CustomEvent<{
			id: string,
		}>) => {
			const resumeSliceId = event.detail.id

			const { hasSystemComponents, latestSystemComponentHasBeenCompleted, activeSystemComponentRequiredFieldsFilled } = this.verifyActiveSystemComponentStatus()

			const systemComponentId = resumeSliceId.split('-slice')[0]

			const mainPartHasBeenAlreadyValidated = Object.keys(this.validatedComponentResumeSlicesById.mainPart).includes(resumeSliceId)
			const systemComponentHasBeenAlreadyValidated = Object.keys(this.validatedComponentResumeSlicesById.systemComponent).includes(resumeSliceId)


			const activateMainComponentEditing = () => {
				this.domUtils.toggleElementState(this.validatedComponentResumeSlicesById.mainPart[resumeSliceId], ['hide'])
				this.domUtils.toggleElementState(this.mainPartFieldset, ['show'])
				if (hasSystemComponents && !latestSystemComponentHasBeenCompleted) this.systemComponentsContainer.lastChild?.remove()
				this.currentEditedComponentId = this.mainPartFieldset.id
			}

			const activateSystemComponentEditing = () => {
				const fieldsetToShow = this.validatedComponentFieldsetById.systemComponent[systemComponentId] as HTMLElement
				this.domUtils.toggleElementState(fieldsetToShow, ['show'])
				this.validatedComponentResumeSlicesById.systemComponent[resumeSliceId].remove()
				delete this.validatedComponentResumeSlicesById.systemComponent[resumeSliceId]
				this.currentEditedComponentId = systemComponentId
				const currentSystemComponents = this.state.get().systemComponents
				const cleanedSystemComponents = currentSystemComponents.filter(component => component.id)
				this.updateState(cleanedSystemComponents, 'systemComponents')
				if (hasSystemComponents && !latestSystemComponentHasBeenCompleted) this.systemComponentsContainer.lastChild?.remove()
			}

			if (mainPartHasBeenAlreadyValidated) activateMainComponentEditing()
			else if (activeSystemComponentRequiredFieldsFilled) this.validateSystemComponent(activateSystemComponentEditing, undefined, false)
			else if (systemComponentHasBeenAlreadyValidated) activateSystemComponentEditing()
		});

	}
}
